import { Pipe, PipeTransform } from '@angular/core';
import { DocumentoHelper } from '../utils/documento.helper';

@Pipe({ name: 'cpfCnpj' })
export class CpfCnpjPipe implements PipeTransform {

  transform(value?: string): string {
    return DocumentoHelper.formatarDocumento(value);
  }
}

@Pipe({ name: 'phoneMask' })
export class PhoneMaskPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return '';

    const phone = value.toString().replace(/\D/g, '');
    if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return value.toString();
  }
}

@Pipe({ name: 'zipCode' })
export class ZipCodePipe implements PipeTransform {
  transform(value?: string): string {
    if (value === null || value === undefined) {
      return '';
    }

    value = value.replace(/\D/g, '');

    if (value.length > 8) {
      value = value.substring(0, 8);
    }

    switch (value.length) {
      case 3:
        value = value.replace(/(\d{2})(\d+)/, '$1.$2');
        break;
      case 4:
        value = value.replace(/(\d{2})(\d+)/, '$1.$2');
        break;
      case 5:
        value = value.replace(/(\d{2})(\d+)/, '$1.$2');
        break;
      case 6:
        value = value.replace(/(\d{2})(\d{3})(\d+)/, '$1$2-$3');
        break;
      case 7:
        value = value.replace(/(\d{2})(\d{3})(\d+)/, '$1$2-$3');
        break;
      case 8:
        value = value.replace(/(\d{2})(\d{3})(\d+)/, '$1$2-$3');
        break;
      default:
        return value;
    }

    return value;
  }
}
